App.directive('showAdvanced', function() { 
    return {
        restrict: 'A',
        scope: {
            id: '@'
        },
        link: function(scope, elm) {
            $(elm[0]).on('click', function() {
                var target = $('.id_' + scope.id);
                var h = target[0].scrollHeight;

                if ($('.accordion').hasClass('opened')) {
                    if ($(target).hasClass('open')) {
                        toggle();
                    } else {
                        $('.accordion .height_0').not(target).removeClass('open');
                        $('.knowledge .height_0').not(target).velocity("stop", true).velocity({
                                height: 0
                            }, {
                                complete: function() {
                                    toggle();
                                }
                            }
                        );
                    }
                } else {
                    toggle();
                }

                function toggle() {
                    if (!$(target).hasClass('open')) {
                        $(target).addClass('open');
                        $(elm[0]).addClass('active');
                        $('.accordion').addClass('opened');
                        $(target).velocity("stop", true).velocity({height: h});
                    } else {
                        $(target).removeClass('open');
                        $('.accordion').removeClass('opened');
                        $(elm[0]).removeClass('active');
                        $(target).velocity("stop", true).velocity({height: 0});
                    }
                }
            });
        }
    }
});